import { render, staticRenderFns } from "./helpCenter-info.vue?vue&type=template&id=f92827ca&scoped=true&"
import script from "./helpCenter-info.vue?vue&type=script&lang=js&"
export * from "./helpCenter-info.vue?vue&type=script&lang=js&"
import style0 from "./helpCenter-info.vue?vue&type=style&index=0&id=f92827ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92827ca",
  null
  
)

export default component.exports